<div *ngIf="!isPdfNull">
    <iframe [src]="pdfSrc" width="100%" height="600px"></iframe>
</div>

<div *ngIf="isPdfNull">
    {{('p_preview_pdf'|translate)}}
  </div>

